module.exports = __webpack_public_path__ + "enterprise-application-integration.1u-mgd9l.svg";